import { __rest } from "tslib";
import * as React from 'react';
import { DatePicker as AntdDatePicker } from 'antd';
import locale from 'antd/es/date-picker/locale/zh_CN';
import variables from '@web-common/styles/export.module.scss';
import classNames from 'classnames';
import './style.scss';
const DatePicker = props => {
    const { className, width } = props, restProps = __rest(props, ["className", "width"]);
    const classes = React.useMemo(() => classNames(`${variables.classPrefix}-date-picker`, className), [className]);
    return React.createElement(AntdDatePicker, Object.assign({ className: classes }, restProps, { style: Object.assign({}, (width ? { width: `${width}px` } : {})) }));
};
DatePicker.defaultProps = {
    locale: locale,
    width: 224,
    dropdownClassName: `${variables.classPrefix}-date-picker-dropdown`,
};
export default DatePicker;
